// supportHandover — the panel's side of "hand over to a person" (support plan,
// 26 Oct). When the agent files a ticket during an in-app call, the panel asks
// support-handover for the ticket card and sends the screen the caller was on,
// so Thomas and Jason see where they were stuck.

/** The ticket card support-handover answers with. */
export interface HandoverTicket { ref: string; callback: boolean; whatsapp: string | null }

/** Did the agent just file a ticket? From the SDK's agent_tool_response event. */
export function isTicketFiled(p: { tool_name?: unknown; is_error?: unknown } | null | undefined): boolean {
  return !!p && p.tool_name === 'file_support_ticket' && p.is_error !== true
}

/** The page title without the app name usePageTitle adds ("Yard · BigPack"), one short line. */
export function pageTitle(title: string): string {
  const cut = title.lastIndexOf(' · ')
  return (cut > 0 ? title.slice(0, cut) : title).replace(/\s+/g, ' ').trim().slice(0, 80)
}

/** Is this card answer usable? A failed or odd answer shows no card. */
export function asTicket(r: unknown): HandoverTicket | null {
  const o = (r && typeof r === 'object' ? r : {}) as Record<string, unknown>
  if (typeof o.ref !== 'string' || !/^[A-Z0-9]{8}$/.test(o.ref)) return null
  const wa = typeof o.whatsapp === 'string' && o.whatsapp.startsWith('https://wa.me/') ? o.whatsapp : null
  return { ref: o.ref, callback: o.callback === true, whatsapp: wa }
}
